import {IconButton, IconButtonProps, useTheme} from '@mui/material';
import {useMySettings} from '_contexts/MySettingsProvider';
import React from 'react';

/**
 * LFCSystemIconButton
 * システム用のアイコンボタンです（ヘッダーメニュー等で使用）。
 * ニューモーフィックスタイルが適用されます。
 * 通常のコンテンツ内では LFCIconButton を使用してください。
 * @param props IconButtonProps
 * @returns
 */
const LFCSystemIconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>((props, ref) => {
  const theme = useTheme();
  const mySettings = useMySettings();
  const isDark = mySettings.isDark;

  // ニューモーフィックスタイル（元々テーマで定義されていたスタイル）
  const neumorphicStyles = {
    color: theme.palette.text.primary,
    marginRight: '5px',
    background: isDark
      ? 'linear-gradient(135deg, rgb(14,14,14) 0%, rgb(38,38,38) 100%)'
      : 'linear-gradient(135deg, rgb(200,200,200) 0%, rgb(230,230,230) 100%)',
    boxShadow: isDark
      ? '-5px 5px 10px rgba(0, 0, 0, 0.2), 5px -5px 10px rgba(0, 0, 0, 0.2), -5px -5px 10px rgba(50, 50, 50, 0.9), 5px 5px 12.5px rgba(0, 0, 0, 0.9), inset 1px 1px 2px rgba(50, 50, 50, 0.3), inset -1px -1px 2px rgba(0, 0, 0, 0.5)'
      : '-5px 5px 10px rgba(180, 180, 180, 0.3), 5px -5px 10px rgba(180, 180, 180, 0.3), -5px -5px 10px rgba(240, 240, 240, 0.9), 5px 5px 12.5px rgba(180, 180, 180, 0.9), inset 1px 1px 2px rgba(240, 240, 240, 0.3), inset -1px -1px 2px rgba(180, 180, 180, 0.5)'
  };

  return (
    <IconButton
      ref={ref}
      {...props}
      sx={{
        ...neumorphicStyles,
        ...props.sx
      }}
    />
  );
});

LFCSystemIconButton.displayName = 'LFCSystemIconButton';

export default LFCSystemIconButton;
